import { render, staticRenderFns } from "./MainMenuButton.vue?vue&type=template&id=61d8c024&"
import script from "./MainMenuButton.vue?vue&type=script&lang=js&"
export * from "./MainMenuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports